let overviewCounter = [];
let overviewCounterNum = [];
let overviewCounterID = [];
let overview = {
    init: function () {
        $('.global-network__overview-num li')
            .each(function (i) {
                $(this)
                    .find('.counter')
                    .attr('id', 'number0' + i);
                overviewCounterID[i] = $(this).find('.counter').attr('id');
                overviewCounterNum[i] = $(this).find('.counter').text();
            })
            .promise()
            .done(function () {
                overviewCounterID.forEach(function (item, index, array) {
                    let id = String(item);
                    let endNum = Number(overviewCounterNum[index]);
                    overviewCounter[index] = new CountUp(id, 0, endNum);
                });
            });
    },
    start: function () {
        overviewCounter.forEach(function (item, idx) {
            overviewCounter[idx].start();
        });
    },
};

const $branchSwiperBtnPrev = $(
    '.global-network__branch-swiper-buttons .btn-prev',
);
const $branchSwiperBtnNext = $(
    '.global-network__branch-swiper-buttons .btn-next',
);

let branchSet = function ($this) {
    for (let i in branchInfo) {
        let slide = `<div class='swiper-slide'>`;
        slide += `<a href='javascript:;' data-open-layered='${branchInfo[i].branchLayered}'>`;
        slide += `<img src='${branchInfo[i].branchImg}' alt=''>`;
        slide += `<div class="global-network__branch-tit">`;
        slide += `<span>${branchInfo[i].countryName}</span>${branchInfo[i].branchName}`;
        slide += `</div></a></div>`;
        $this.appendSlide(slide);
    }
};

const BranchSwiper = new Swiper('.global-network__branch-swiper .swiper', {
    width: gvr_winW - 60,
    spaceBetween: 20,
    slideActiveClass: 'is-active',

    //effect: 'fade',
    scrollbar: {
        el: '.global-network__branch-swiper-scrollbar',
        draggable: false,
    },
    pagination: {
        el: '.global-network__branch-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number) {
            number = String(number);
            if (number.length < 2) number = '0' + number;
            return number;
        },
        formatFractionTotal: function (number) {
            number = String(number);
            if (number.length < 2) number = '0' + number;
            return number;
        },
    },
    on: {
        init: function (el) {
            branchSet(this);
            // $('.global-network__branch-swiper .swiper-slide a').attr(
            //     'data-open-layered',
            //     'branchLayered',
            // );
        },
    },
});

const $gnHeader = $('.app-header');
const $gnNav = $('.gn_navigation');
const $gnNavTab = $gnNav.find('.lx_tab');
let gnPosition = {};
let gnCurrent = [];

const gn_scrollSpy = {
    init: function () {
        return new Promise(function (resolve, reject) {
            $gnNav.find('.lx_tab').empty();
            $('.js_global-network-spy').each(function (i) {
                //Make TAB
                let title = $(this).find('.global-network__title').text();
                $gnNav
                    .find('.lx_tab')
                    .append(
                        `<button type="button" role="tab" aria-selected='false'>${title}</button>`,
                    );

                //Section Position
                gnPosition[i] = parseInt($(this).offset().top);
            });
            resolve('Success!');
        }).then(function () {
            $gnNav.find('button:first-child').remove();
            gn_scrollSpy.trigger(gvr_st);
            gfn_tab.init();
        });
    },
    trigger: function (st) {
        return new Promise(function (resolve, reject) {
            gnCurrent.length = 0;
            for (let top in gnPosition) {
                // console.log(st, gnPosition[top]);
                if (st + triggerPosition >= gnPosition[top]) {
                    gnCurrent.push(top);
                    // console.log(gnCurrent);
                }
            }
            resolve('Success!');
        }).then(function () {
            if (gnCurrent.length) {
                // if (gnCurrent.length > 1) {
                //     $gnNav.find('.lx_tab-wrap').addClass('is-fixed');
                // } else {
                //     $gnNav.find('.lx_tab-wrap').removeClass('is-fixed');
                // }
                let current = Math.max(...gnCurrent);
                $('.js_global-network-spy').eq(current).addClass('is-active');
                //console.log(current);
                if (current > 0) {
                    let $activeBtn = $gnNav.find('button').eq(current - 1);
                    let activeBtnLeft = $activeBtn.offset().left;
                    $gnNav.find('button').attr('aria-selected', false);
                    $activeBtn.attr('aria-selected', true);

                    //위치 맞추기
                    if ($activeBtn.outerWidth() + activeBtnLeft >= gvr_winW) {
                        $gnNavTab.scrollLeft(
                            $activeBtn.outerWidth() + activeBtnLeft,
                        );
                    }
                    if (activeBtnLeft <= 0) {
                        $gnNavTab.scrollLeft(0);
                    }
                } else {
                    $gnNav.find('button').attr('aria-selected', false);
                }
                switch (current) {
                    case 0:
                        $gnHeader.addClass('is-transparent');
                        break;
                    case 1:
                        $gnHeader.removeClass('is-transparent');
                        overview.start();
                        break;
                    default:
                        $gnHeader.removeClass('is-transparent');
                        break;
                }
            }
        });
    },
};

let triggerPosition = 110; //header + tab

$(document)
    .on('click', '.gn_navigation button', function () {
        let idx = $(this).index();
        triggerPosition = $app.hasClass('is-scrolldown') ? 50 : 110;
        $scrollBody
            .stop()
            .animate(
                { scrollTop: gnPosition[idx + 1] - triggerPosition + 'px' },
                200,
                function () {
                    //움직이는 부분 감안하여 재 조정
                    let targetPosition = gnPosition[idx + 1] - triggerPosition;
                    //console.log(gvr_st, targetPosition, triggerPosition);
                    if (gvr_st != targetPosition) {
                        $scrollBody.scrollTop(targetPosition + 1);
                    }
                },
            );
    })
    .on(
        'click',
        '.lx_post-navigation a, .global-network__notice-list a',
        function () {
            if (!$(this).hasClass('is-disabled'))
                $('.branch__notice-layered .content').scrollTop(0);
        },
    )
    .on('click', '.global-network__branch-swiper .swiper-slide a', function () {
        if (!$(this).hasClass('is-disabled'))
            $('.branch-layered .content').scrollTop(0);
    })
    .on('click', '.global_network__history .lx_btn-view-more', function () {
        $('.global_network__history').find('ul').toggleClass('is-active');
        $('.global_network__history')
            .find('ul')
            .one('transitionend', function () {
                gn_scrollSpy.init();
            });
    });

$(window)
    .on('scroll', function () {
        gvr_st = $(this).scrollTop();
        gn_scrollSpy.trigger(gvr_st);

        $('.app-header__inner')
            .find('.js_toggle-class')
            .removeClass('is-active');
    })
    .on('load', function () {
        overview.init();
        gn_scrollSpy.init();
        gn_scrollSpy.trigger(gvr_st);
    })
    .on('resize', function () {
        gfn_vhFix();
        gfn_resizeEnd(function () {
            gn_scrollSpy.init();
        });
    });

//버튼 서로 닫히기
$('.app-header__language').on('click', 'button', function () {
    $('.app-header__global').children('button').removeClass('is-active');
});
$('.app-header__global').on('click', 'button', function () {
    $('.app-header__language').children('button').removeClass('is-active');
});
